export default __webpack_public_path__ + "static/media/1-1.ef6a150e.jpg";